import { Link } from 'react-router-dom';
import { V2_TEMPLATE_LIST } from '@/components/weddingTemplatesV2/WeddingTemplateV2Workspace';

export default function WeddingTemplateV2GalleryPage() {
  return (
    <div className="min-h-screen bg-stone-100 py-10" data-testid="template-v2-gallery-page">
      <div className="container-wedding space-y-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-xs uppercase tracking-[0.2em] text-[#5C0120] font-semibold mb-3">Wedding Website Builder · V2</p>
          <h1 className="text-4xl sm:text-5xl font-semibold text-stone-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Distinct Template System Preview
          </h1>
          <p className="text-stone-600">
            Sample couple: <strong>Sofia & Daniel</strong> · <strong>14 Oct 2026</strong> · <strong>The Rock Hotel, Gibraltar</strong>
          </p>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6" data-testid="template-v2-preview-grid">
          {V2_TEMPLATE_LIST.map((template) => (
            <article key={template.key} className="rounded-2xl border border-stone-200 bg-white p-5 shadow-sm" data-testid={`template-v2-card-${template.key}`}>
              <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
                <div>
                  <h2 className="text-xl font-semibold text-stone-900" data-testid={`template-v2-name-${template.key}`}>{template.name}</h2>
                  <p className="text-sm text-stone-600" data-testid={`template-v2-description-${template.key}`}>{template.description}</p>
                </div>
                <Link
                  to={`/wedding-v2/${template.key}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm font-semibold text-[#5C0120] hover:text-[#5C0120]/80"
                  data-testid={`template-v2-open-link-${template.key}`}
                >
                  Open full preview →
                </Link>
              </div>

              <div className="rounded-[2rem] border-[8px] border-stone-900 bg-black overflow-hidden mx-auto w-[390px] max-w-full" data-testid={`template-v2-phone-frame-${template.key}`}>
                <iframe
                  title={`${template.name} mobile preview`}
                  src={`/wedding-v2/${template.key}`}
                  className="w-full h-[760px] bg-white"
                  loading="lazy"
                  data-testid={`template-v2-iframe-${template.key}`}
                />
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
